'use strict';

var React = require('react');

var SvgBugMajor = function SvgBugMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 2a1 1 0 1 0-2 0v.228a7.166 7.166 0 0 0 3.187 5.96c-.056.338-.1.685-.131 1.039a11.254 11.254 0 0 0-3.357-1.124l-.534-.09a1 1 0 1 0-.329 1.973l.534.09a9.254 9.254 0 0 1 3.648 1.452c.012.347.03.687.057 1.02l-.607.729a11 11 0 0 0-2.4 5.233l-.054.326a1 1 0 1 0 1.973.328l.054-.325a9 9 0 0 1 1.473-3.636c.639 2.289 1.968 3.797 4.486 3.797s3.848-1.508 4.487-3.797a8.999 8.999 0 0 1 1.473 3.636l.054.325a1 1 0 1 0 1.973-.328l-.055-.326a11 11 0 0 0-2.4-5.233l-.607-.729c.027-.337.046-.683.058-1.035l.4-.3a5.236 5.236 0 0 1 2.282-.977l1.5-.25a1 1 0 1 0-.329-1.972l-1.5.25a7.236 7.236 0 0 0-2.401.855 13.69 13.69 0 0 0-.122-.932 7.166 7.166 0 0 0 3.187-5.959v-.228a1 1 0 1 0-2 0v.228c0 1.502-.65 2.894-1.727 3.855-.878-2.448-2.463-4.083-4.273-4.083-1.81 0-3.395 1.635-4.272 4.083a5.165 5.165 0 0 1-1.728-3.855v-.228z"
  }));
};

exports.SvgBugMajor = SvgBugMajor;
